
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic14Off as ObiHydraulic14OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-14-off.js';
 
 
 

 
 export const ObiHydraulic14Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-14-off',
   elementClass: ObiHydraulic14OffElement,
   events: {
     
   }
  });
 
 